export default __webpack_public_path__ + "static/media/image-work-team-m@3x.2aa6320a.webp";